import { View } from '@components/primitives';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import React from 'react';

interface DotComponentProps extends React.ComponentProps<typeof View> {}

function DotComponent(props: DotComponentProps): React.JSX.Element {
  return <View backgroundColor={colors.neutral.darkMist} style={appStyles.dotStyles} {...props} />;
}

export default DotComponent;
